import { isMobile } from "react-device-detect";

export const thumbnailProgressBarStyle = {
  progressTrack: {
    backgroundColor: "#5B5B5B",
  },
  progressBar: {
    backgroundColor: "#0085FF",
  },
};


export const toolContainerStyles = {
  // marginRight: "5px",
  // marginLeft: "5px",
  display: "flex",
  alignItems: "center",
  height: "100%"
};

export const toolBarFlex = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "100%"
};

export const toolTipStyles = {
  root: {
    height: isMobile ? "100%" : "65%",
    display: "flex",
    alignItems: "center",
  },
};

export const toolStyle = {
  margin: `${isMobile ? "0px" : "0px 5px"}`,
  height: "100%",
  width: "fit-content",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center"
};
